<div *ngIf="isHandheld$ | async" edsSpacing="md"></div>

<eds-panel
  edsSpacing="sm"
  [hasBorders]="true"
  [hasBorderRadius]="false"
  [hasPadding]="true"
  edsBackground
  theme="white"
>
  <eds-proximal
    placement="DistributionRatesAndYieldsProximalTop"
  ></eds-proximal>

  <!-- Section Title -->
  <eds-section-header
    [isLight]="true"
    size="h6"
    [title]="'products.distribution-rates-and-yields-title' | translate"
    [subTitle]="'products.distribution-rates-and-yields-desc' | translate"
    [level]="3"
    edsSpacing="md"
    theme="primary"
    caveatPlacement="Distribution:RatesAndYieldsSection"
  ></eds-section-header>

  <div *ngIf="(isHandheld$ | async) === false">
    <!-- Rate & Breakpoints Section -->
    <eds-info-item
      *ngIf="showRatesBreakpointsSection"
      [info]="rateBreakPoints"
      edsSpacing="xs"
    >
    </eds-info-item>

    <!-- Distribution Rate Section -->
    <eds-info-item
      *ngIf="yieldsInfo?.disrate"
      [info]="yieldsInfo.disrate"
      edsSpacing="xs"
    >
    </eds-info-item>

    <!-- 30-Day Standardized Yield Section -->
    <eds-info-item
      *ngIf="yieldsInfo?.standard"
      [info]="yieldsInfo.standard"
      edsSpacing="xs"
    >
    </eds-info-item>

    <!-- Taxable Equivalent Yield Section -->
    <eds-info-item
      *ngIf="yieldsInfo?.taxequivalent"
      [info]="yieldsInfo.taxequivalent"
      edsSpacing="xs"
    >
    </eds-info-item>

    <!-- Taxable Equivalent Distribution Rate Section -->
    <eds-info-item
      *ngIf="yieldsInfo?.taxequivalentdisrate"
      [info]="yieldsInfo.taxequivalentdisrate"
      edsSpacing="xs"
    >
    </eds-info-item>

    <!-- Current Yield Section -->
    <eds-info-item
      *ngIf="yieldsInfo?.current"
      [info]="yieldsInfo.current"
      edsSpacing="xs"
    >
    </eds-info-item>

    <!-- Effective Yield Section -->
    <eds-info-item
      *ngIf="yieldsInfo?.effective"
      [info]="yieldsInfo.effective"
      edsSpacing="xs"
    >
    </eds-info-item>
  </div>

  <div *ngIf="isHandheld$ | async">
    <!-- Rate & Breakpoints Section -->
    <div *ngIf="showRatesBreakpointsSection">
      <eds-section-header
        [title]="'products.distribution-rate-and-breakpoints' | translate"
        [level]="6"
        [asOfLabel]="'products.as-of' | translate"
        [asOfDate]="salesChargeBreakPoints[0].asOfDate"
        edsSpacing="sm"
        [analyticsName]="
          'products.distribution-rate-and-breakpoints' | translate
        "
        [tooltip]="
          getTooltipContent('products.distribution-rate-and-breakpoints')
        "
      ></eds-section-header>

      <eds-info-item
        *ngFor="let item of mobileRateBreakPoints"
        [info]="item"
        edsSpacing="xs"
      >
      </eds-info-item>
    </div>

    <!-- Distribution Rate Section -->
    <div *ngIf="yieldsInfo?.disrate">
      <eds-section-header
        [title]="'products.distribution-yield-disrate-title' | translate"
        [level]="6"
        [asOfLabel]="'products.as-of' | translate"
        [asOfDate]="salesChargeBreakPoints[0].asOfDate"
        edsSpacing="sm"
        [analyticsName]="
          'products.distribution-yield-disrate-title' | translate
        "
        [tooltip]="getTooltipContent('products.distribution-yield-disrate')"
      ></eds-section-header>

      <eds-info-item
        *ngFor="let item of yieldsInfo.disrate.values"
        [info]="item"
        edsSpacing="xs"
      >
      </eds-info-item>
    </div>

    <!-- 30-Day Standardized Yield Section -->
    <div *ngIf="yieldsInfo?.standard">
      <eds-section-header
        [title]="'products.distribution-yield-standard-title' | translate"
        [level]="6"
        [asOfLabel]="'products.as-of' | translate"
        [asOfDate]="yields.stdYieldThirtyDayAsofDate"
        edsSpacing="sm"
        [analyticsName]="
          'products.distribution-yield-standard-title' | translate
        "
        [tooltip]="getTooltipContent('products.distribution-yield-standard')"
      ></eds-section-header>

      <eds-info-item
        *ngFor="let item of yieldsInfo.standard.values"
        [info]="item"
        edsSpacing="xs"
      >
      </eds-info-item>
    </div>

    <!-- Taxable Equivalent Yield Section -->
    <div *ngIf="yieldsInfo?.taxequivalent">
      <eds-section-header
        [title]="'products.distribution-yield-taxequivalent-title' | translate"
        [level]="6"
        [asOfLabel]="'products.as-of' | translate"
        [asOfDate]="yields.stdYieldThirtyDayAsofDate"
        edsSpacing="sm"
        [analyticsName]="
          'products.distribution-yield-taxequivalent-title' | translate
        "
        [tooltip]="
          getTooltipContent('products.distribution-yield-taxequivalent')
        "
      ></eds-section-header>

      <eds-info-item
        *ngFor="let item of yieldsInfo.taxequivalent.values"
        [info]="item"
        edsSpacing="xs"
      >
      </eds-info-item>
    </div>

    <!-- Taxable Equivalent Distribution Rate Section -->
    <eds-info-item
      *ngIf="yieldsInfo?.taxequivalentdisrate"
      [info]="yieldsInfo.taxequivalentdisrate"
      edsSpacing="xs"
    >
    </eds-info-item>

    <!-- Current Yield Section -->
    <div *ngIf="yieldsInfo?.current">
      <eds-section-header
        [title]="'products.distribution-yield-current-title' | translate"
        [level]="6"
        [asOfLabel]="'products.as-of' | translate"
        [asOfDate]="navDate"
        edsSpacing="sm"
        [analyticsName]="
          'products.distribution-yield-current-title' | translate
        "
        [tooltip]="getTooltipContent('products.distribution-yield-current')"
      ></eds-section-header>

      <eds-info-item
        *ngFor="let item of yieldsInfo.current.values"
        [info]="item"
        edsSpacing="xs"
      >
      </eds-info-item>
    </div>

    <!-- Effective Yield Section -->
    <div *ngIf="yieldsInfo?.effective">
      <eds-section-header
        [title]="'products.distribution-yield-effective-title' | translate"
        [level]="6"
        [asOfLabel]="'products.as-of' | translate"
        [asOfDate]="navDate"
        edsSpacing="sm"
        [analyticsName]="
          'products.distribution-yield-effective-title' | translate
        "
        [tooltip]="getTooltipContent('products.distribution-yield-effective')"
      ></eds-section-header>

      <eds-info-item
        *ngFor="let item of yieldsInfo.effective.values"
        [info]="item"
        edsSpacing="xs"
      >
      </eds-info-item>
    </div>
  </div>

  <eds-proximal
    placement="DistributionRatesAndYieldsProximalBottom"
  ></eds-proximal>
</eds-panel>
